var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.offset > 0),expression:"offset > 0"}],attrs:{"fab":"","fixed":"","right":"","bottom":"","color":"primary"},on:{"click":function($event){return _vm.$vuetify.goTo(0, {duration:500, easing:'easeInQuad'})}}},[_c('v-icon',[_vm._v("mdi-chevron-up")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }